import React from 'react';
import PropTypes from 'prop-types';
import GalleryBoxMain from '../../../legacy/flux/components/gallery/GalleryBoxMain.react';
import GalleryBoxThumbs from '../../../legacy/flux/components/gallery/GalleryBoxThumbs.react';
import GalleryStore from '../../../legacy/flux/stores/GalleryStore';
import GalleryActionCreators from '../../../legacy/flux/actions/GalleryActionCreators';

/**
 * MemberImageGallery
 *
 * Used inline in new profile view
 *
 * @extends React.Component
 */
class MemberImageGallery extends React.Component {
  state = {
    images: GalleryStore.getMemberImages(this.props.memberId),
    galleryOpen: localStorage.getItem('galleryOpen') !== 'false',
  };

  componentDidMount() {
    const { memberId } = this.props;
    GalleryStore.addChangeListener(this.onChange);

    const { images } = this.state;
    if (!images) {
      GalleryStore.setLoad(true);
      GalleryActionCreators.galleryLoad(memberId);
    }
  }

  componentWillUnmount() {
    // Clear member images when unmounting
    GalleryStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      images: GalleryStore.getMemberImages(this.props.memberId),
      // member: MemberStore.get(this.props.memberId),
    });
  };

  // toggle gallery open/close
  toggleGallery = () => {
    this.setState((prevState) => {
      const newGalleryOpen = !prevState.galleryOpen;
      // Update localStorage with the new value
      localStorage.setItem('galleryOpen', newGalleryOpen);
      return { galleryOpen: newGalleryOpen };
    });
  };

  // open gallery if not already open
  toggleGalleryOpen = () => {
    this.setState((prevState) => {
      if (!prevState.galleryOpen) {
        localStorage.setItem('galleryOpen', true);
        return { galleryOpen: true };
      }
      return { galleryOpen: prevState.galleryOpen };
    });
  };

  // render
  render() {
    const { galleryOpen, images } = this.state;
    const { memberId } = this.props;

    // Don't render anything if we don't have a member ID
    if (!memberId) return null;

    return (
      <div style={{ position: 'relative', marginBottom: '1rem' }} id="gallery">
        {images && (
          <button
            type="button"
            onClick={this.toggleGallery}
            className="btn btn-transparent btn--small pbxs"
            style={{
              position: 'absolute', top: '2px', right: '2px', zIndex: 66, backgroundColor: '#2B2B2B', color: 'white',
            }}
          >
            {galleryOpen ? '✕ ' : '∨ '}
            {galleryOpen ? 'Aizvērt' : 'Atvērt'}
          </button>
        )}
        {images && (
          <div>
            {galleryOpen && (
              <GalleryBoxMain
                onClose={undefined}
                showReportButton={false}
                showLikeButton
                showComplimentButton
                displayInline
              />
            )}
            <GalleryBoxThumbs
              memberId={memberId}
              displayInline
              thumbnailSize="m"
              onClickAction={this.toggleGalleryOpen}
            />
          </div>
        )}
      </div>
    );
  }
}

MemberImageGallery.propTypes = {
  memberId: PropTypes.string,
};

MemberImageGallery.defaultProps = {
  memberId: null,
};

export default MemberImageGallery;
